module.exports = "<div class=\"verticalcenter text-center login\">\n    <div class=\"card\">\n        <h3 class=\"card-header primary-color white-text text-center\">LOGIN</h3>\n        <div class=\"card-body\">\n            <div id=\"googleBtn\" class=\"btn btn-primary\">\n                Iniciar Sesión\n            </div>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/login/login.component.html
// module id = ./src/app/shared/components/login/login.component.html
// module chunks = main